import React from 'react';

import Box from '@mui/material/Box';

import DisableProduct from 'components/Icons/DisabledProduct';

import { UserLicensesResponse } from 'utils/api/modules/user/user.types';

import ActiveProduct from 'components/Icons/ActiveProduct';

import { useStore } from 'utils/hooks/store';

import { productLicensesFor } from 'core/constants';

import { ProductAccessContainer, ProductAccessText } from './styles';

const UserProductsCell: React.FunctionComponent<{ licenses: UserLicensesResponse }> = ({ licenses }) => {
  const { session } = useStore();

  const licensesToDisplay = productLicensesFor({
    hasEventsLicense: session.hasEventsLicense,
    hasRisksLicense: session.hasRisksLicense,
  });

  return (
    <Box sx={{ display: 'flex' }}>
      {licensesToDisplay.map(({ key, label }) => (
        <ProductAccessContainer key={key}>
          {licenses[key as keyof UserLicensesResponse] ? <ActiveProduct /> : <DisableProduct />}
          <ProductAccessText>{label}</ProductAccessText>
        </ProductAccessContainer>
      ))}
    </Box>
  );
};

export default UserProductsCell;
